import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import alertTypes from '../../constants/alertTypes';
import { ALERTS_TIMEOUT } from '../../constants';
import { Intent, Position, Toaster } from "@blueprintjs/core";
import { handleAlert } from "../../actions/index";
import "./index.css";

class AlertToaster extends React.Component {

  toaster;
  refHandlers = {toaster: (ref) => this.toaster = ref};

  componentWillUpdate(nextProps) {
    if (nextProps.alert.type) {
      this.showAlert(nextProps.alert.type, nextProps.alert.message);
      this.resetAlert();
    }
  }

  resolveIntent = (type) => {
    let intent = Intent.PRIMARY;
    if (type === alertTypes.ERROR) {
      intent = Intent.DANGER
    } else if (type === alertTypes.SUCCESS) {
      intent = Intent.SUCCESS
    }
    return intent;
  };

  showAlert = (type, message) => {
    this.toaster.show({
      message: message,
      intent: this.resolveIntent(type),
      timeout: ALERTS_TIMEOUT
    });
  };

  resetAlert = () => {
    this.props.handleAlert({type: null, message: null});
  };

  render() {
    return <Toaster className="Toaster"
                    position={Position.TOP}
                    ref={this.refHandlers.toaster}/>;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handleAlert
  }, dispatch)
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertToaster);



// WEBPACK FOOTER //
// ./src/containers/AlertToaster/index.js